const XS = "480px";
const SM = "576px";
const MD = "765px";
const LG = "960px";
const XL = "1260px";
const XXL = "1600px";

export const MobileVersionXS = `(max-width: ${XS})`;
export const MobileVersion = `(max-width: ${SM})`;
export const UpToMobileWidth = `(max-width: ${MD})`;
export const UpToContentPageWidth = `(max-width: ${LG})`;
export const UpToTabletWidth = `(max-width: ${XL})`;
export const UpToLaptop = `(max-width: ${XXL})`;
export const ComputerVersion = `(min-width: ${XXL})`;